import TextInput from './TextInput';
import Tabs from './Tabs';
import Pillars from './Pillars';
import Field from './Field';
import FieldContent from './FieldContent';
import ScrollTo from './ScrollTo';
import Social from './Social';
import NavMobile from './NavMobile';
import Man from './Man';
import Form from './Form';
import DownloadButton from './DownloadButton';

const Components = {
    TextInput: TextInput,
    Tabs: Tabs,
    Pillars: Pillars,
    Field: Field,
    FieldContent: FieldContent,
    ScrollTo: ScrollTo,
    Social: Social,
    NavMobile: NavMobile,
    Man: Man,
    Form: Form,
    DownloadButton: DownloadButton
};

export default Components;


// WEBPACK FOOTER //
// ./components/index.js